import React from 'react';
import "./Footer.css"
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import GoogleIcon from '@mui/icons-material/Google';
function Footer() {
  return <div>
      <div className="footerCntainer">

          <div className="footerContact">
              <h1>Contact</h1>
              <div>
                  Email : pk9923446@gmail.com, deepesh.97kumar@gmail.com
              </div>
          </div>

          <div className="footerwidth">
          <div className="oneFooterContainer">
              <div>
                    <i><InstagramIcon /></i>
                    <p>Grow</p>
                    <p>India</p>

                    <p>Help</p>
                    <p>Code</p>
                    <p>Tech</p>
                    <p>Learn</p>

              </div>
              <div>
                    <i><FacebookIcon /></i>
                    <p>Html</p>
                    <p>CSS</p>

                    <p>JavaScript</p>
                    <p>React</p>
                    <p>Redux</p>
                    <p>Easy</p>

              </div>
          </div>
          <div className="twoFooterContainer">
              <div>
                    <i><TwitterIcon /></i>
                    <p>Java</p>
                    <p>Help</p>

                    <p>Modern</p>
                    <p>ROR</p>
                    <p>Bharat</p>
                    <p>Quiz</p>

              </div>
              <div>
                    <i><GoogleIcon /></i>
                    <p>Project</p>
                    <p>Contact</p>

                    <p>Contribute</p>
                    <p>Pay</p>
                    <p>Motimate</p>
                    <p>Earn</p>

              </div>
          </div>
          </div>
      </div>

  </div>;
}

export default Footer;
